import { appConfig } from 'brand-config';

/**
 * Agency Reports (#36219): the monthly Agency Performance Report PDFs a brand's data team drops in
 * Google Cloud Storage, surfaced from the account menu at /agency-reports.
 *
 * Two brand bits in `featureFlags.agencyReports`: `enabled` is the master switch (internal users
 * see the item); `visibleToAgencies` additionally opens it to non-internal users who hold
 * CanViewAgencyReports (the Agency Principal role's permission, #35833). Mirrors
 * brand-config-be's resolveAgencyReportsAccess, which the lambda enforces server-side, so the UI
 * never shows a door the API would refuse. No flag = off for everyone.
 */
export const resolveAgencyReportsAccess = (flag, { isInternal, canViewAgencyReports }) => {
  if (!flag?.enabled) {
    return false;
  }
  if (isInternal) {
    return true;
  }
  return Boolean(flag.visibleToAgencies) && Boolean(canViewAgencyReports);
};

/**
 * Whether this environment's backend is provisioned: create-env.js emits VITE_AGENCY_REPORTS_CONFIGURED
 * only when the Doppler config carries the lambda's GCS secret. Lower environments without it hide
 * the feature entirely instead of showing a page that can only answer "temporarily unavailable".
 */
export const isAgencyReportsConfigured = () => import.meta.env?.VITE_AGENCY_REPORTS_CONFIGURED === 'true';

export const isAgencyReportsVisible = (session) =>
  Boolean(session) &&
  isAgencyReportsConfigured() &&
  resolveAgencyReportsAccess(appConfig?.featureFlags?.agencyReports, {
    isInternal: Boolean(session.isInternalAgent),
    canViewAgencyReports: Boolean(session.canViewAgencyReports)
  });

/** Internal users pick any agency; agency users are pinned server-side to their own stem. */
export const canSearchAgencyReports = (session) => Boolean(session?.isInternalAgent);
